import React, { useState, useEffect } from 'react';
import { useApiCall } from '../../hooks/useApi';
import { useNotificationHook } from '../../hooks/useNotificationHook';
import api from '../../services/api';

const DualSmtpManagement = () => {
     const [settings, setSettings] = useState({
     bluehost: {
       enabled: false,
       host: '',
       port: '',
       secure: false,
       username: '',
       password: '',
       from_email: '',
       from_name: ''
     },
     gmail: {
       enabled: false,
       host: '',
       port: '',
       secure: false,
       username: '',
       password: '',
       from_email: '',
       from_name: ''
     },
     active_provider: 'bluehost'
   });

  const [testEmail, setTestEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({});
  const { notify } = useNotificationHook();

  // Load settings on component mount
  useEffect(() => {
    loadSettings();
    loadStatus();
  }, []);

     const loadSettings = async () => {
     try {
       const response = await api.get('/dual-smtp/settings');
       if (response.data.success) {
         setSettings(response.data.data);
       }
     } catch (error) {
       notify.error('Failed to load SMTP settings', 'Loading Error');
     }
   };

  const loadStatus = async () => {
    try {
      const response = await api.get('/dual-smtp/status');
      if (response.data.success) {
        setStatus(response.data.data);
      }
    } catch (error) {
      console.error('Failed to load SMTP status:', error);
    }
  };

  const handleToggleProvider = async (provider) => {
    setLoading(true);
    try {
      const response = await api.post(`/dual-smtp/toggle/${provider}`);
      if (response.data.success) {
        notify.success(response.data.message, 'Success');
        await loadSettings();
        await loadStatus();
      } else {
        notify.error(response.data.message, 'Toggle Error');
      }
    } catch (error) {
      notify.error('Failed to toggle SMTP provider', 'Toggle Error');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateSettings = async (provider, updatedSettings) => {
    setLoading(true);
    try {
      const response = await api.put(`/dual-smtp/settings/${provider}`, updatedSettings);
      if (response.data.success) {
        notify.success(response.data.message, 'Success');
        await loadSettings();
        await loadStatus();
      } else {
        notify.error(response.data.message, 'Update Error');
      }
    } catch (error) {
      notify.error('Failed to update SMTP settings', 'Update Error');
    } finally {
      setLoading(false);
    }
  };

  const handleTestProvider = async (provider) => {
    if (!testEmail) {
      notify.error('Please enter a test email address', 'Validation Error');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post(`/dual-smtp/test/${provider}`, { testEmail });
      if (response.data.success) {
        notify.success(response.data.message, 'Test Success');
      } else {
        notify.error(response.data.message, 'Test Error');
      }
    } catch (error) {
      notify.error('Failed to test SMTP provider', 'Test Error');
    } finally {
      setLoading(false);
    }
  };

  const handleTestActive = async () => {
    if (!testEmail) {
      notify.error('Please enter a test email address', 'Validation Error');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/dual-smtp/test-active', { testEmail });
      if (response.data.success) {
        notify.success(response.data.message, 'Test Success');
      } else {
        notify.error(response.data.message, 'Test Error');
      }
    } catch (error) {
      notify.error('Failed to test active SMTP', 'Test Error');
    } finally {
      setLoading(false);
    }
  };

           const SmtpProviderCard = ({ provider, config, isActive }) => {
        const [isEditing, setIsEditing] = useState(false);
        const [editConfig, setEditConfig] = useState({ ...config });
        const [showPassword, setShowPassword] = useState(false);

        // Update editConfig when config changes (especially when password is loaded)
        useEffect(() => {
          setEditConfig({ ...config });
        }, [config]);

    const handleSave = () => {
      handleUpdateSettings(provider, editConfig);
      setIsEditing(false);
    };

         const handleCancel = () => {
       setEditConfig({ ...config });
       setIsEditing(false);
     };

    return (
             <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-md p-4 sm:p-6 border-2 ${isActive ? 'border-green-500' : 'border-gray-200 dark:border-gray-600'}`}>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
                         <h3 className="text-xl font-semibold text-gray-800 dark:text-white capitalize">{provider} SMTP</h3>
                         <span className={`px-2 py-1 rounded-full text-xs font-medium ${
               isActive ? 'bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200' : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'
             }`}>
               {isActive ? 'Active' : 'Inactive'}
             </span>
          </div>
          <div className="flex space-x-2">
            <button
              onClick={() => handleToggleProvider(provider)}
              disabled={loading}
              className={`px-4 py-2 rounded-md text-sm font-medium ${
                config.enabled
                  ? 'bg-red-500 hover:bg-red-600 text-white'
                  : 'bg-green-500 hover:bg-green-600 text-white'
              } disabled:opacity-50`}
            >
              {config.enabled ? 'Disable' : 'Enable'}
            </button>
            <button
              onClick={() => handleTestProvider(provider)}
              disabled={loading || !config.enabled}
              className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md text-sm font-medium disabled:opacity-50"
            >
              Test
            </button>
          </div>
        </div>

        {isEditing ? (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Host</label>
                                 <input
                   type="text"
                   value={editConfig.host}
                   onChange={(e) => setEditConfig({ ...editConfig, host: e.target.value })}
                   className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                 />
              </div>
              <div>
                                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Port</label>
                                 <input
                   type="number"
                   value={editConfig.port}
                   onChange={(e) => setEditConfig({ ...editConfig, port: e.target.value })}
                   className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                 />
              </div>
            </div>
                         <div className="grid grid-cols-2 gap-4">
               <div>
                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Username</label>
                 <input
                   type="text"
                   value={editConfig.username}
                   onChange={(e) => setEditConfig({ ...editConfig, username: e.target.value })}
                   className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                 />
               </div>
                               <div>
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Password</label>
                  <div className="relative">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={editConfig.password || ''}
                      onChange={(e) => setEditConfig({ ...editConfig, password: e.target.value })}
                      placeholder="Enter SMTP password"
                      className="w-full px-3 py-2 pr-10 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                    >
                      {showPassword ? (
                        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
                        </svg>
                      ) : (
                        <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      )}
                    </button>
                  </div>
                </div>
             </div>
             <div className="grid grid-cols-2 gap-4">
               <div>
                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">From Email</label>
                 <input
                   type="email"
                   value={editConfig.from_email}
                   onChange={(e) => setEditConfig({ ...editConfig, from_email: e.target.value })}
                   className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                 />
               </div>
               <div>
                 <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">From Name</label>
                 <input
                   type="text"
                   value={editConfig.from_name}
                   onChange={(e) => setEditConfig({ ...editConfig, from_name: e.target.value })}
                   className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
                 />
               </div>
             </div>

                         <div className="flex items-center space-x-2">
               <input
                 type="checkbox"
                 id={`secure-${provider}`}
                 checked={editConfig.secure === true || editConfig.secure === 'true'}
                 onChange={(e) => setEditConfig({ ...editConfig, secure: e.target.checked })}
                 className="rounded border-gray-300 dark:border-gray-600 text-blue-600 focus:ring-blue-500 bg-white dark:bg-gray-800"
               />
               <label htmlFor={`secure-${provider}`} className="text-sm font-medium text-gray-700 dark:text-gray-300">
                 Use SSL/TLS
               </label>
             </div>
            <div className="flex space-x-2">
              <button
                onClick={handleSave}
                disabled={loading}
                className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-md text-sm font-medium disabled:opacity-50"
              >
                Save
              </button>
              <button
                onClick={handleCancel}
                className="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-md text-sm font-medium"
              >
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div className="space-y-3">
                         <div className="grid grid-cols-2 gap-4 text-sm">
               <div>
                 <span className="font-medium text-gray-600 dark:text-gray-400">Host:</span>
                 <p className="text-gray-800 dark:text-white">{config.host}</p>
               </div>
               <div>
                 <span className="font-medium text-gray-600 dark:text-gray-400">Port:</span>
                 <p className="text-gray-800 dark:text-white">{config.port}</p>
               </div>
               <div>
                 <span className="font-medium text-gray-600 dark:text-gray-400">Username:</span>
                 <p className="text-gray-800 dark:text-white">{config.username}</p>
               </div>
                                <div>
                   <span className="font-medium text-gray-600 dark:text-gray-400">Password:</span>
                   <p className="text-gray-800 dark:text-white">
                     {config.password && config.password.trim() !== '' ? '••••••••' : 'Not set'}
                   </p>
                 </div>
               <div>
                 <span className="font-medium text-gray-600 dark:text-gray-400">From Email:</span>
                 <p className="text-gray-800 dark:text-white">{config.from_email}</p>
               </div>
               <div>
                 <span className="font-medium text-gray-600 dark:text-gray-400">From Name:</span>
                 <p className="text-gray-800 dark:text-white">{config.from_name}</p>
               </div>
               <div>
                 <span className="font-medium text-gray-600 dark:text-gray-400">SSL/TLS:</span>
                 <p className="text-gray-800 dark:text-white">{config.secure ? 'Yes' : 'No'}</p>
               </div>
             </div>
            <button
              onClick={() => setIsEditing(true)}
              className="px-4 py-2 bg-gray-500 hover:bg-gray-600 text-white rounded-md text-sm font-medium"
            >
              Edit Settings
            </button>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="max-w-6xl mx-auto p-4 sm:p-6">
      <div className="mb-8">
        <h1 className="text-xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-2">Dual SMTP Management</h1>
        <p className="text-gray-600 dark:text-gray-300">
          Configure and manage both Bluehost and Gmail SMTP providers. Only one provider can be active at a time.
        </p>
      </div>

      {/* Status Overview */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4 sm:p-6 mb-6">
        <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">System Status</h2>
        <div className="grid grid-cols-3 gap-4">
          <div className="text-center">
            <div className={`w-4 h-4 rounded-full mx-auto mb-2 ${
              status.connection_status ? 'bg-green-500' : 'bg-red-500'
            }`}></div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Connection</p>
            <p className="text-lg font-semibold text-gray-800 dark:text-white">
              {status.connection_status ? 'Connected' : 'Disconnected'}
            </p>
          </div>
          <div className="text-center">
            <div className="w-4 h-4 rounded-full mx-auto mb-2 bg-blue-500"></div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Active Provider</p>
            <p className="text-lg font-semibold text-gray-800 dark:text-white capitalize">
              {settings.active_provider || 'None'}
            </p>
          </div>
          <div className="text-center">
            <div className="w-4 h-4 rounded-full mx-auto mb-2 bg-yellow-500"></div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Total Providers</p>
            <p className="text-lg font-semibold text-gray-800 dark:text-white">2</p>
          </div>
        </div>
      </div>

      {/* Test Email Section */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-4 sm:p-6 mb-6">
        <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">Test Email Configuration</h2>
        <div className="flex space-x-4 items-end">
          <div className="flex-1">
                         <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Test Email Address</label>
                         <input
               type="email"
               value={testEmail}
               onChange={(e) => setTestEmail(e.target.value)}
               placeholder="Enter email address to test"
               className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
             />
          </div>
          <button
            onClick={handleTestActive}
            disabled={loading || !testEmail}
            className="px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md font-medium disabled:opacity-50"
          >
            Test Active SMTP
          </button>
        </div>
      </div>

      {/* SMTP Providers */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:p-6">
        <SmtpProviderCard
          provider="bluehost"
          config={settings.bluehost}
          isActive={settings.active_provider === 'bluehost'}
        />
        <SmtpProviderCard
          provider="gmail"
          config={settings.gmail}
          isActive={settings.active_provider === 'gmail'}
        />
      </div>

             {/* Instructions */}
       <div className="mt-8 bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 sm:p-6">
         <h3 className="text-lg font-semibold text-blue-900 dark:text-blue-100 mb-3">Setup Instructions</h3>
         <div className="space-y-3 text-sm text-blue-800 dark:text-blue-200">
                     <div>
             <strong>Bluehost SMTP:</strong> Use your Bluehost email credentials. Host: 162.214.80.9, Port: 465, SSL: Yes, Password: Your Bluehost email password
           </div>
           <div>
             <strong>Gmail SMTP:</strong> Requires App Password. Enable 2FA, generate App Password, use smtp.gmail.com:587, Password: Your Gmail App Password
           </div>
          <div>
            <strong>Toggle:</strong> Only one provider can be active at a time. Enabling one will automatically disable the other.
          </div>
          <div>
            <strong>Testing:</strong> Always test your configuration before making it active to ensure emails will be delivered.
          </div>
        </div>
      </div>
    </div>
  );
};

export default DualSmtpManagement;
